module.exports = __webpack_public_path__ + "static/media/fda.51254cc6.svg";